<template>
    <el-upload
        class="avatar-uploader"
        :action="IMAGE_UPLOAD_PRO_URL"
        :show-file-list="false"
        accept="image/*"
        :on-success="uploadCoverImgSuccess"
        :before-upload="beforeUploadCoverImg"
        :headers="header"
    >
        <img v-if="value" :src="value" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>

        <div v-if="value" class="shadow" @click.stop="onRemoveHandler()">
            <i class="el-icon-delete"></i>
        </div>
    </el-upload>
</template>
<script>
import Picture from './Picture';
import { IMAGE_UPLOAD_PRO_URL } from '@/common/const';
export default {
    name: 'ImgSingleUpload',
    components: {
        Picture
    },
    props: {
        // 图片数据(图片url组成的数组) 通过v-model传递
        value: {
            type: String,
            default: ''
        },
        // 限制上传的图片数量
        limit: {
            type: Number,
            default: 1
        },
        // 限制上传图片的文件大小(kb)
        size: {
            type: Number,
            default: 500
        },
        // 是否是单图上传(单图上传就是已传图片和上传按钮重叠)
        isSingle: {
            type: Boolean,
            default: false
        },
        // 是否显示选择图片
        ImgVisible: {
            type: Boolean,
            default: false
        },
        // 是否使用图片压缩
        useCompress: {
            type: Boolean,
            default: false
        },
        // 图片显示的宽度(px)
        width: {
            type: Number,
            default: 100
        },
        // 图片显示的高度(px)
        height: {
            type: Number,
            default: 100
        },
        imgType: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },

    data() {
        return {
            IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_PRO_URL,
            header: {},
            isUploading: false, // 正在上传状态
            isFirstMount: true // 控制防止重复回显
        };
    },

    mounted() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
    },

    methods: {
        uploadCoverImgSuccess(res, file, index) {
            if (res.code == 1) {
                this.$emit('update:value', res.data.uri);
            }
        },
        beforeUploadCoverImg(file) {
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (this.imgType.length && !this.imgType.includes(testmsg)) {
                this.$message.error(`只能上传${this.imgType.toString()}`);
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return;
            }
        },
        // 移除单张图片
        onRemoveHandler(index) {
            this.$confirm('确定删除该图片?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$emit('update:value', '');
                    console.log(this.value);
                })
                .catch(() => {});
        }
    }

    // components: { vuedraggable }
};
</script>
<style scoped>
::v-deep.avatar-uploader .el-upload {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

::v-deep.avatar-uploader .el-upload:hover .shadow {
    opacity: 1 !important;
}

.shadow {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    padding: 2px;
    cursor: pointer;
}
</style>
